module.exports = __webpack_public_path__ + "static/media/hide.3a8db07e.png";